import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b46e46fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-page" }
const _hoisted_2 = { class: "login-page__form-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "login-page__title" }, "Login", -1))
const _hoisted_4 = { class: "login-page__form" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "username" }, "Username", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Password", -1))
const _hoisted_7 = { class: "login-page__forgot" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Forgot password?")
const _hoisted_9 = { class: "login-page__form-buttons" }
const _hoisted_10 = {
  key: 0,
  class: "login-page__error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("form", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          name: "username",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.username]
        ]),
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          type: "password",
          name: "password",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.password]
        ]),
        _createElementVNode("p", _hoisted_7, [
          _createVNode(_component_RouterLink, { to: "/resend-password" }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.formErr)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.formErr), 1))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "button button--big button--green",
            onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirmCred && _ctx.confirmCred(...args)), ["prevent"]))
          }, "Login")
        ])
      ])
    ])
  ]))
}